import {
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { taxJson } from "../../../DynamicFormsJson/MastersJSON/Tax";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class TaxView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: taxJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            this.setState({
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Tax Name",
                  value:
                    data.data !== null && data.data.name !== null
                      ? data.data.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "SGST",
                  value:
                    data.data !== null && data.data.sgst !== null
                      ? data.data.sgst
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "CGST",
                  value:
                    data.data !== null && data.data.cgst !== null
                      ? data.data.cgst
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "IGST",
                  value:
                    data.data !== null && data.data.igst !== null
                      ? data.data.igst
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Cess",
                  value:
                    data.data !== null && data.data.cess !== null
                      ? data.data.cess
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "HSN Code",
                  value:
                    data.data !== null && data.data.hsnCode !== null
                      ? data.data.hsnCode
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Search By",
                  value:
                    data.data !== null && data.data.type !== null
                      ? data.data.type == "0"
                        ? "Goods"
                        : "Services"
                      : "",
                },
                // {
                //   xs: 12,
                //   sm: 6,
                //   md: 6,
                //   lg: 6,
                //   label: "Search By",

                //   value: (
                //     <Grid item xs={12} sm={12} md={12} lg={12} container>
                //       <FormControl component="fieldset">
                //         <RadioGroup
                //           value={data.data.type}
                //           row
                //           name="transporterFor"
                //         >
                //           <FormControlLabel
                //             value="0"
                //             control={<Radio disabled />}
                //             label="Goods"
                //           />
                //           <FormControlLabel
                //             value="1"
                //             control={<Radio disabled />}
                //             label="Services"
                //           />
                //         </RadioGroup>
                //       </FormControl>
                //     </Grid>
                //   ),
                // },
              ],
            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Tax View"}
            fieldMeta={[]}
            apiBaseURL={taxJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(TaxView);
